import { Component } from 'vue-property-decorator';
import TopNav from '@/components/topnav/TopNav.vue';
import MessageBanner from '@/components/topnav/MessageBanner.vue';
import ProjectContainer from './ProjectContainer.vue';
import ProjectContainerMobile from './ProjectContainerMobile.vue';
import EditorBase from '../editor/EditorBase';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SetupSLIDBanner from '@/components/topnav/SetupSLIDBanner.vue';
import ActingAsBanner from '@/components/topnav/ActingAsBanner.vue';
import { EModalName } from '@/helpers/modal';
@Component({
  components: {
    TopNav,
    ProjectContainer,
    ProjectContainerMobile,
    ConfirmationModal,
    SetupSLIDBanner,
    ActingAsBanner,
    MessageBanner,
  },
})
export default class ProjectPage extends EditorBase {
  mounted() {
    this.openCheckoutModalMiniOnUserFlag();
  }

  get projectContainerComponent() {
    return this.isMobile ? ProjectContainerMobile : ProjectContainer;
  }
}
